import { useState } from 'react';
import { useFragment } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarWithLabel, Box, Button, ButtonGroup, Chip, GridCell, IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ContactFragmentDoc } from './Contact.gql';
import { ContactValue } from './ContactValue';
import { DeleteContact } from './DeleteContact';
import { UpdateContact } from './UpdateContact';
import { StyledBox } from './styled';
export function Contact(props) {
    const { from, onSelect } = props;
    const [update, setUpdate] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const showUpdateDialog = () => setUpdate(true);
    const closeUpdateDialog = () => setUpdate(false);
    const showDeleteContact = () => setConfirmDelete(true);
    const closeDeleteContact = () => setConfirmDelete(false);
    const { complete, data } = useFragment({
        fragment: ContactFragmentDoc,
        from,
    });
    const handleSelect = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        onSelect({
            name: (_a = data.name) !== null && _a !== void 0 ? _a : '',
            firstName: (_b = data.firstName) !== null && _b !== void 0 ? _b : '',
            lastName: (_c = data.lastName) !== null && _c !== void 0 ? _c : '',
            email: (_d = data.email) !== null && _d !== void 0 ? _d : '',
            mobile: (_e = data.mobile) !== null && _e !== void 0 ? _e : '',
            label: (_f = data.label) !== null && _f !== void 0 ? _f : '',
            title: (_g = data.title) !== null && _g !== void 0 ? _g : '',
            authenticationMode: (_h = data.authenticationMode) !== null && _h !== void 0 ? _h : undefined,
        });
    };
    if (!complete) {
        return null;
    }
    const { name, email, label, mobile, isPublic } = data || {};
    return (<GridCell width={{ base: 12, md: 6 }}>
      <StyledBox>
        <Box alignItems="center">
          <AvatarWithLabel shape="square" size="md" appearance="dark" title={name} subtitle={email}>
            <Falcon icon="user"/>
          </AvatarWithLabel>

          {update && <UpdateContact data={data} onClose={closeUpdateDialog}/>}

          {confirmDelete && <DeleteContact id={data.id} onClose={closeDeleteContact}/>}

          <Box ml="auto" gap="md">
            {isPublic && (<Chip appearance="secondary" label={t({ message: 'Public', comment: 'Contact library - Public contact' })}/>)}
            <ButtonGroup>
              <Button type="button" appearance="secondary" size="xs" onClick={handleSelect}>
                <Trans comment="Contact library - Select contact button label">Select</Trans>
              </Button>
              <Menu.Root target={<IconButton type="button" appearance="secondary" size="xs" aria-label={t({ message: 'More options', comment: 'Contact library - More options button' })}>
                    <Falcon icon="ellipsis-v"/>
                  </IconButton>}>
                <Menu.Item onClick={showUpdateDialog}>
                  <Falcon icon="pen"/>
                  <Trans comment="Contact library - Edit contact">Edit</Trans>
                </Menu.Item>
                <Menu.Item onClick={showDeleteContact}>
                  <Falcon icon="trash"/>
                  <Trans comment="Contact library - Delete contact">Delete</Trans>
                </Menu.Item>
              </Menu.Root>
            </ButtonGroup>
          </Box>
        </Box>

        <ContactValue title={t({
            message: 'Company',
            comment: 'Contact library - Company',
        })} value={label}/>

        <ContactValue title={t({
            message: 'Mobile',
            comment: 'Contact library - Mobile',
        })} value={mobile || ''}/>
      </StyledBox>
    </GridCell>);
}
